import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular';

@Component({
    selector: 'app-team-footer',
    templateUrl: './team-footer.component.html',
    styleUrls: ['./team-footer.component.scss'],
    standalone: true,
})
export class TeamFooterComponent extends FooterComponent {
  constructor() {
    super();
  }
}
